<block-ui>


    <div class="row p-1 d-flex justify-content-start">
        <div>
            <button class="form-control form-control-sm btn-light shadow-sm btn-st" (click)="RaiseReportUserModal(content)">
                <i class="fa fa-plus" aria-hidden="true"></i> Agregar
            </button>
        </div>
    </div>
    <div class="row mt-2 tableFixHead">
        <table class="table table-striped table-sm table-hover">
            <thead>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">Usuario</th>
                    <th scope="col">Descripción</th>
                    <th scope="col" class="text-center">Activo</th>
                    <th scope="col"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let reportUser of reportUsers; let i = index" class="p-0">
                    <td scope="row">{{(i + 1)}}</td>
                    <td>{{reportUser.Username}}</td>
                    <td>{{reportUser.Description}}</td>
                    <td class="text-center"><i class="fa fa-{{reportUser.Active ? 'check': 'times'}}"></i></td>
                    <td class="justify-content-center option clasesita">
                        <i class="fa fa-edit" style="cursor: pointer;" title="Editar usuario de reporte" (click)="GetReportUser(reportUser.Id, content)"></i>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <ng-template #content let-modal>
        <div class="modal-header">
            <h5 class="modal-title">Usuario de Reporte</h5>
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <form [formGroup]="reportUserForm">
                <div class="form-group" style="display: none;">
                    <label for="">Id</label>
                    <input type="text" class="form-control form-control-sm" formControlName="Id">
                </div>
                <div class="form-group">
                    <label for="">Nombre de usuario *</label>
                    <input type="text" class="form-control form-control-sm" formControlName="Username">
                    <small class="text-danger" *ngIf="reportUserForm.get('Username').invalid && reportUserForm.get('Username').touched">
                        El nombre de usuario es requerido
                    </small>
                </div>
                <div class="form-group">
                    <label for="">Descripción *</label>
                    <input type="text" class="form-control form-control-sm" formControlName="Description">
                    <small class="text-danger" *ngIf="reportUserForm.get('Description').invalid && reportUserForm.get('Description').touched">
                        La descripción es requerida
                    </small>
                </div>
                <div class="form-group">
                    <label for="exampleInputPassword1">Contraseña <ng-container *ngIf="reportUserForm.get('Id').value === -1">*</ng-container></label><br>
                    <div class="form-check form-check-inline w-100">
                        <input type="password" *ngIf="!isPasswordInputReandOnly" readonly class="form-control form-control-sm mr-2 " formControlName="Password">
                        <input type="password" *ngIf="isPasswordInputReandOnly" class="form-control form-control-sm mr-2 " formControlName="Password">
                        <input class="form-check-inputm ml-2" formControlName="UpdatePassword" type="checkbox" style="transform: scale(1.5); cursor: pointer" title="Editar contraseña" (click)="ToggleInputPasswordType()">
                    </div>
                </div>
                <div class="form-check">
                    <input type="checkbox" class="form-check-input" formControlName="Active" style="transform: scale(1.5); cursor: pointer">
                    <label class="form-check-label" for="exampleCheck1">Activo</label>
                </div>
            </form>

            <div class="row">
                <div class="col-sm-4 offset-sm-4">

                    <button type="button" class="form-control form-control-sm btn-light shadow-sm btn-st float-right" (click)="Store()"><i class="fa fa-floppy-o" aria-hidden="true"></i> Guardar</button>
                </div>
                <div class="col-sm-4">
                    <button type="button" class="form-control form-control-sm btn-light shadow-sm btn-st" (click)="CloseModal()"><i class="fa fa-times-circle" aria-hidden="true"></i> Cerrar&nbsp;</button>

                </div>
            </div>
        </div>
    </ng-template>
</block-ui>
